import { Trash2 } from 'lucide-react';

import { GlassButton } from './GlassButton.js';
import { GlassModal } from './GlassModal.js';

import type { ReactElement } from 'react';

interface GlassConfirmDialogProps {
  open: boolean;
  title: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
  variant?: 'danger' | 'default';
  loading?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export function GlassConfirmDialog({
  open,
  title,
  message,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  variant = 'default',
  loading = false,
  onConfirm,
  onCancel,
}: GlassConfirmDialogProps): ReactElement {
  const isDanger = variant === 'danger';
  return (
    <GlassModal open={open} onClose={onCancel}>
      <h3 className="text-lg font-semibold text-text">{title}</h3>
      <p className="text-sm text-text-secondary mt-2">{message}</p>
      <div className="flex items-center justify-end gap-3 mt-6">
        <GlassButton variant="secondary" size="md" onClick={onCancel} disabled={loading}>
          {cancelLabel}
        </GlassButton>
        <GlassButton
          variant={isDanger ? 'danger' : 'primary'}
          size="md"
          onClick={onConfirm}
          disabled={loading}
        >
          {isDanger && <Trash2 size={14} />}
          {loading ? 'Processing\u2026' : confirmLabel}
        </GlassButton>
      </div>
    </GlassModal>
  );
}
